<template>
  <svg :class="className" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_36_76924" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="50" height="50">
      <rect y="50" width="50" height="50" transform="rotate(-90 0 50)" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_36_76924)">
      <path d="M32.291 25.0002L22.916 15.6252L19.9993 18.5939L26.4056 25.0002L19.9993 31.4064L22.916 34.3752L32.291 25.0002ZM45.8327 25.0002C45.8327 27.8821 45.2858 30.5904 44.1921 33.1252C43.0983 35.6599 41.6139 37.8647 39.7389 39.7397C37.8639 41.6147 35.6591 43.0991 33.1244 44.1929C30.5896 45.2866 27.8813 45.8335 24.9994 45.8335C22.1174 45.8335 19.4091 45.2866 16.8743 44.1929C14.3396 43.0991 12.1348 41.6147 10.2598 39.7397C8.38477 37.8647 6.90039 35.6599 5.80664 33.1252C4.71289 30.5904 4.16601 27.8821 4.16601 25.0002C4.16601 22.1182 4.71289 19.4099 5.80664 16.8752C6.90039 14.3404 8.38476 12.1356 10.2598 10.2606C12.1348 8.38557 14.3396 6.9012 16.8743 5.80745C19.4091 4.7137 22.1174 4.16682 24.9993 4.16682C27.8813 4.16682 30.5896 4.7137 33.1243 5.80745C35.6591 6.9012 37.8639 8.38557 39.7389 10.2606C41.6139 12.1356 43.0983 14.3404 44.1921 16.8752C45.2858 19.4099 45.8327 22.1182 45.8327 25.0002Z" fill="#CC0605" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    className: { type: String, default: '' }
  }
}
</script>
